module.exports = __webpack_public_path__ + "static/media/askersund.25c02935.jpeg";